import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
/**
 * Endpoint for initializing a patient record in the database.
 * Creates a new patient from Cognito data if one doesn't exist, and returns the patient ID.
 */
export const PatientInitializeEndpoint = defineEndpoint({
    name: 'PatientInitialize',
    output: defineEndpoint.output(),
});
//# sourceMappingURL=PatientInitializeEndpoint.js.map